module.exports = "query FontawesomeIconsQuery($search:String){icons:fontAwesomeIcons(search:$search){name styles label}}"